(function () {
  'use strict';
  function syncOffer(form) {
    var r = form.querySelector('input[name="id"]:checked');
    if (!r) return;
    form.querySelectorAll('[data-dv-atc-price]').forEach(function (n) { n.textContent = r.dataset.price; });
    document.querySelectorAll('[data-dv-sticky="' + form.getAttribute('id') + '"]').forEach(function (s) {
      var name = s.querySelector('[data-dv-sticky-name]');
      var price = s.querySelector('[data-dv-sticky-price]');
      if (name) name.textContent = r.dataset.name;
      if (price) price.textContent = r.dataset.price;
    });
  }
  function addToDrawer(form, e) {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    var r = form.querySelector('input[name="id"]:checked');
    var Ev = window.DvCartLinesUpdateEvent;
    if (!drawer || !r || !Ev || typeof Theme === 'undefined' || !Theme.routes) return;
    e.preventDefault();
    var btns = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')).concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + form.id + '"]')));
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    function done() { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); }
    var added = false;
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var deferred = Ev.createPromise();
    form.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: r.value, quantity: 1 }], promise: deferred.promise }));
    fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }], sections: sectionIds.join(',') }) })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.message || 'add');
        added = true;
        return fetch(Theme.routes.cart_url + '.js').then(function (c) { return c.json(); }).then(function (cart) {
          deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'dv-offer-form', itemCount: 1, sections: res.sections, didError: false } });
          done();
        });
      })
      .catch(function (err) {
        deferred.reject(err);
        done();
        if (added) { window.location.href = Theme.routes.cart_url; } else { HTMLFormElement.prototype.submit.call(form); }
      });
  }
  function initOffers() {
    document.querySelectorAll('[data-dv-offer]').forEach(function (form) {
      if (form.dataset.dvReady) return;
      form.dataset.dvReady = '1';
      form.addEventListener('change', function () { syncOffer(form); });
      form.addEventListener('submit', function (e) { addToDrawer(form, e); });
      syncOffer(form);
    });
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    var added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      var day = r.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return r;
  }
  function initEta() {
    var fmt;
    try { fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return; }
    var now = new Date();
    document.querySelectorAll('[data-dv-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min || '2', 10);
      var max = parseInt(el.dataset.max || '5', 10);
      var label = el.dataset.label || 'Livraison offerte';
      var span = el.querySelector('span');
      if (!span) return;
      span.innerHTML = label + ' · commande aujourd’hui, reçue entre le <strong>' + fmt.format(addBusinessDays(now, min)) + '</strong> et le <strong>' + fmt.format(addBusinessDays(now, max)) + '</strong>';
    });
  }
  function initSticky() {
    document.querySelectorAll('[data-dv-sticky]').forEach(function (bar) {
      var form = document.getElementById(bar.dataset.dvSticky);
      if (!form || !('IntersectionObserver' in window) || bar.dataset.dvReady) return;
      bar.dataset.dvReady = '1';
      var target = form.querySelector('[type="submit"]') || form;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
        });
      }).observe(target);
    });
  }
  function initTabs() {
    document.querySelectorAll('[data-dv-tabs]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      function select(i) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
          if (panels[j]) panels[j].hidden = j !== i;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(n); tabs[n].focus();
        });
      });
    });
  }
  function initGalleries() {
    document.querySelectorAll('[data-dv-gallery]').forEach(function (g) {
      var track = g.querySelector('.dv-gallery__track');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.dv-gallery__thumb'));
      if (!track || !thumbs.length) return;
      function mark(i) { thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var s = track.children[i];
          if (!s) return;
          track.scrollTo({ left: s.offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
          mark(i);
        });
      });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var w = track.children[0] ? track.children[0].offsetWidth + 10 : 1;
          mark(Math.round(track.scrollLeft / w));
        }, 80);
      }, { passive: true });
    });
  }
  function initUpgrade() {
    document.querySelectorAll('[data-dv-upgrade]').forEach(function (btn) {
      if (btn.dataset.dvReady) return;
      btn.dataset.dvReady = '1';
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.line, quantity: 0 }) })
          .then(function () {
            return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }] }) });
          })
          .then(function () { window.location.reload(); })
          .catch(function () { btn.disabled = false; });
      });
    });
  }
  function init() { initOffers(); initEta(); initSticky(); initTabs(); initGalleries(); initUpgrade(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();